import {

    SET_SOCIALMEDIA
  } from '../types/types';
  
  export const setSocialMedia = (value) => {
    return {
      type: SET_SOCIALMEDIA,
      payload: { data: value },
    };
  };
  